import { CarriersController } from "../../../controllers/carriers-controller";
import { Carrier } from "../../../models/carrier"
import { CarrierFilter } from "../../../models/carrier-filter"
import { BusyService } from "../../../services/busy-service";
import { WebApiService } from "../../../services/web-api-service";
import { AureliaCookie } from 'aurelia-cookie';

import { observable, computedFrom, autoinject } from "aurelia-framework";
import { singleton } from 'aurelia-framework';
import { AppMessageService } from "../../../services/app-message-service";
import { DialogService } from "aurelia-dialog";
import { UpdateUserDialog } from "../../dialogs/update-user-dialog";
import { PageMessageService } from "../../../services/page-message-service";
import { SimpleDialog } from "../../dialogs/simple-dialog";
import { SecurityService } from "../../../services/security-service"; 6
import { CmpTaskDto } from "../../../data/typegen/dtos/cmp-task-dto";
import { CmpTaskCommentDto } from "../../../data/typegen/dtos/cmp-task-comment-dto";
import { DisplayValuePair } from "../../../data/typegen/dtos/display-value-pair";
import { TaskState } from "../../../data/enums/taskState";
import { NewUserRequestTaskDto } from "../../../data/typegen/dtos/new-user-request-task-dto";
import { RequestDto } from "../../../data/typegen/dtos/request-dto";
import { DoUiActionDto } from "../../../data/typegen/dtos/do-ui-action-dto";
import { CmpTaskBaseDto } from "../../../data/typegen/dtos/cmp-task-base-dto";
import { RequestTypeIds } from "../../../data/typegen/enums/request-type-ids";
import { Router } from 'aurelia-router';
import { ActivityStreamItemBase } from "../../../data/typegen/dtos/activity-stream-item-base";
import { RequestStateIds } from "../../../data/typegen/enums/request-state-ids";
import { RequestDetailsScreenDataDto } from "../../../data/typegen/dtos/request-details-screen-data-dto";


@autoinject()
export class MyTicketsPage {


    constructor(
        public securityService: SecurityService,
        private busyService: BusyService,
        private appMsg: AppMessageService,
        private msg: PageMessageService,
        private router: Router,
        private dialogService: DialogService,
        private api: WebApiService) {
    }


    public filter: "all" = "all";
    public includeInactive: false;

    public async setFilter(filter) {
        this.filter = filter;
        await this.loadRequests();
        this.filteredRequests = this.getFilteredRequests(this.filter);
    }

    requests = [];
    filteredRequests: Array<any> = [];

    private getFilteredRequests(filter: "all") {
        var filtered = this.requests;
        return filtered;
    }


   
    async activate(params) {
        AureliaCookie.set('nav_stack', 'requests', {});
        await this.initializePage();
    }

    async refresh() {
        this.initializePage();
    }

    async initializePage() {
        await this.loadRequests();
        this.setFilter(this.filter);
    }


    async loadRequests() {
        this.busyService.on();
        try {
            var result;
            result = await this.api.get("Tasks", "GetMyTickets", { includeInactive: this.includeInactive });
            this.requests = JSON.parse(result.response);
        } finally {
            this.busyService.off();
        }
    }
}